import React from "react";
import { Form, Alert, Button } from "react-bootstrap";


const LoginForm = ({validated,handleSubmit,errorMsg,username,password,setUsername,setPassword}) => {
    return (

        <Form validated={validated} onSubmit={handleSubmit}>
            {errorMsg ? (
                <Alert variant="danger">{errorMsg}</Alert>
            ) : null}
            <h4 className="camlogin-heading">Sign In</h4>
            <div className="form-group">
                <Form.Control
                    required
                    type="text"
                    placeholder="User Name"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please enter a valid user name
                </Form.Control.Feedback>
            </div>
            <div className="form-group">
                <Form.Control
                    required
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                    Please enter a valid password
                </Form.Control.Feedback>
            </div>
            <Button
                type="submit"
                variant="primary"
                className="cmslogin-submit"
            >
                Log In
            </Button>
        </Form>

    );
};

export default LoginForm;